var observer;

function awaitSpecialPanel(mutations) {
    let special = document.querySelector("#special");
    if (special === null) {
        return;
    }

    observer.disconnect();
    fixTopSpacerHeight();
}

export default function initTopSpacer() {
    observer = new MutationObserver(awaitSpecialPanel);
    observer.observe(document, {childList: true, subtree: true})
}

function fixTopSpacerHeight() {
    const topSpacer = document.querySelector("#top-spacer");
    const header = document.querySelector("#header");

    if (topSpacer === undefined || header === undefined) {
        return;
    }

    topSpacer.style.height = header.clientHeight + "px";
}
